import { useExperiments } from './context';
import { ExperimentVariant } from './types';

export function useFlag(
  flagKey: string,
  defaultValue: string | number | boolean
): {
  value: string | number | boolean;
  loading: boolean;
  error: string | null;
  variant: ExperimentVariant | null;
} {
  const { flags, loading, error } = useExperiments();

  const variant = flags[flagKey] || null;
  const value = variant?.value ?? defaultValue;

  return {
    value,
    loading,
    error,
    variant,
  };
}
